interface AuthenticationResponse {
	request_id: string;
	status_code: string;
	user_message_title: string;
	user_message_desc: string;
	body_signature: string;
	data: {
		retry: boolean;
		issuer?: {
			url: string;
			key: string;
		};
	};
}

interface IssuerData {
  url: string;
  key: string;
}

interface Data {
	retry: boolean;
	issuer?: IssuerData;
}

function isAuthenticationResponse(obj: any): obj is AuthenticationResponse {
	return obj && 
	typeof obj.request_id === 'string' && 
	typeof obj.status_code === 'string' && 
	typeof obj.user_message_title === 'string' && 
	typeof obj.user_message_desc === 'string' && 
	typeof obj.body_signature === 'string' && 
	typeof obj.data === 'object' && 
	typeof obj.data.retry === 'boolean' &&
	(obj.data.issuer === undefined || (
		typeof obj.data.issuer === 'object' &&
		typeof obj.data.issuer.url === 'string' &&
		typeof obj.data.issuer.key === 'string'
	));
}

export class AuthenticationDto {
	requestID: string;
	statusCode: string;
	userMessageTitle: string;
	userMessageDesc: string;
	bodySignature: string;
	data: Data;

	constructor(json: AuthenticationResponse) {
		if (!isAuthenticationResponse(json)) {
			throw new Error('Invalid AuthenticationResponse json');
		}
		this.requestID = json.request_id;
		this.statusCode = json.status_code;
		this.userMessageTitle = json.user_message_title;
		this.userMessageDesc = json.user_message_desc;
		this.bodySignature = json.body_signature;
		this.data = {
			retry: json.data.retry,
			issuer: json.data.issuer
				? {
					url: json.data.issuer.url,
					key: json.data.issuer.key
				}
				: undefined
		};
	}
}
